import { cn } from '~/styles/extended-theme';

import { Button } from '../ui/button';

interface AppInfoCardProps {
  isAthleteSection: boolean;
  hasRightBorder?: boolean;
  hideButton?: boolean;
  className?: string;
}

export function AppInfoCard({
  isAthleteSection,
  hasRightBorder = false,
  hideButton = false,
  className,
}: AppInfoCardProps) {
  const gymOwnerFeatures = [
    'Get discovered.',
    'Grow your members.',
    'Promote classes & events.',
    'Simplify check-ins.',
  ];

  const athleteFeatures = [
    'Find gyms.',
    'Connect with fighters.',
    'Track your progress.',
    'Receive special discounts.',
  ];

  const features = isAthleteSection ? athleteFeatures : gymOwnerFeatures;
  const title = isAthleteSection ? 'ATHLETES' : 'GYM OWNERS';
  const sectionId = isAthleteSection ? 'athletes-section' : 'gym-owners-section';
  const buttonText = isAthleteSection ? 'Join our athlete network' : 'List your gym for free';

  return (
    <div
      className={cn(
        'flex w-1/2 flex-col justify-between p-5',
        hasRightBorder ? 'border-r border-gray-400' : '',
        className,
      )}
    >
      <div className="flex flex-col">
        <p className="mb-2 text-subtitle1 text-destructive">{title}</p>
        <ul className={cn('list-disc pl-6 text-body2 text-black', !hideButton ? 'mb-5' : '')}>
          {features.map((feature, index) => (
            <li key={index}>{feature}</li>
          ))}
        </ul>
      </div>
      {!hideButton ? (
        <Button
          variant="destructive"
          className="p-3 text-xs text-white md:h-[30px] md:px-4"
          onClick={() => document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' })}
        >
          {buttonText}
        </Button>
      ) : null}
    </div>
  );
}
